import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import List from '../../List/List';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import { FormattedDate } from 'react-intl';
import ListActionItems from '../../List/ListActionItems';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

import IconCheckBox from '../../Icons/IconCheckBox';
import IconCheckBoxChecked from '../../Icons/IconCheckBoxChecked';

class FanFeedTagsList extends List {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  constructor() {
    super();
    this.confirmRemoveMessage = (
      <FormattedMessage
        id="fanBoxMessage.remove"
        defaultMessage="Are you sure you want to delete message?"
      />
    );
  }

  render() {
    let { add, list, items, hasMore, loading } = this.props
    
    let records = list.map(id => items[id]);

    let {
      palette: { labelColor },
      baseTheme: {
        palette: { primary1color }
      }
    } = this.context.muiTheme;

    let tableColumnStyle = {
      color: primary1color,
      boxSizing: 'border-box'
    };

    let tableHeaderStyle = {
      color: labelColor,
      boxSizing: 'border-box'
    };

    let fixedColumnStyle = Object.assign({}, tableColumnStyle, { width: 140 });

    let idColumnStyle = { ...tableColumnStyle, maxWidth: 370 };

    let { tableHeaderColumn } = this.context.muiTheme;

    return (
      <div>
        <LoggedAppBar title="FanFeed Tags" isStatic />
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader
                adjustForCheckbox={false}
                displaySelectAll={false}
                enableSelectAll={false}
                style={{
                  backgroundColor: tableHeaderColumn.bgColor
                }}
              >
                <TableRow>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 100}}>
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 140}}>
                    Author
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 140}}>
                    Content
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 80}}>
                    Published time
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, width: 60}}>
                    Likes
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 140}}>
                    #Hashtag
                  </TableHeaderColumn>
                  <TableHeaderColumn style={{...tableHeaderStyle, maxWidth: 100}}>
                    Options
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0 ? (
                  records.map(
                    ({
                      id,
                      status,
                      email,
                      content,
                      publishDate,
                      likes,
                      hashtag
                    }) => (
                      <TableRow key={id}>
                        <TableRowColumn
                          style={Object.assign({}, fixedColumnStyle, {
                            textAlign: 'center'
                          })}
                        >
                          {status ? (
                            <IconCheckBoxChecked />
                          ) : (
                            <IconCheckBox />
                          )}
                        </TableRowColumn>
                        <TableRowColumn style={idColumnStyle}>
                          { email }
                        </TableRowColumn>
                        <TableRowColumn style={tableColumnStyle}>
                          {content}
                        </TableRowColumn>
                        <TableRowColumn style={fixedColumnStyle}>
                          {publishDate ? (
                            <FormattedDate value={publishDate} />
                          ) : (
                            '-'
                          )}
                        </TableRowColumn>
                        <TableRowColumn style={tableColumnStyle}>
                          {likes}
                        </TableRowColumn>
                        <TableRowColumn style={tableColumnStyle}>
                          {hashtag}
                        </TableRowColumn>
                        <TableRowColumn style={fixedColumnStyle}>
                          <ListActionItems
                            remove={this.props.delete}
                            record={items[id]}
                            confirmMessageLabel={this.confirmRemoveMessage}
                          />
                        </TableRowColumn>
                      </TableRow>
                    ),
                  )
                ) : (
                  <TableRow>
                    <TableRowColumn columnNumber={6}>Empty list</TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>

        <AddButton onClick={add} />
      </div>
    );
  }
}

export default FanFeedTagsList



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedTagsList/FanFeedTagsList.jsx